import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { getCashOutDetailByID, getCashOutList } from "../store/thunk";
import { Modal } from "../../shared/Modal";
import { FiAlertTriangle, FiPrinter, FiSearch } from 'react-icons/fi';
import { Loading } from "../../../../components/Loading";
import { Table } from "../../../../components/Table";
import { TableSummary } from "../../../../components/TableSummary";

export const ReportCashOut = () => {

    let f = new Date(); let dia = f.getDate(); let mes = f.getMonth() + 1; if (dia < 10) dia = "0" + dia; if (mes < 10) mes = "0" + mes; let today = f.getFullYear() + "-" + mes + "-" + dia;
    const { register, control, handleSubmit, watch, reset, getValues, setValue, formState: { errors } } = useForm({ model: 'all' });
    const { isLoading, list_cashOut } = useSelector(state => state.cashOut);
    const dispatch = useDispatch();
    const searchData = (data) => {
        let fechaI = data.fechaInicial; let fechaF = data.fechaFinal; let word = data.termino;
        dispatch(getCashOutList(fechaI, fechaF, word))
    }

    const searchDetail = (id) => {
        // console.log(id);
        dispatch(getCashOutDetailByID(id))
    }

    let columns = [
        {
            header: 'ID',
            dataIndex: 'id',
            classHeader: 'text-start',
            classRow: 'text-start',
            showTotal: false,
        },
        {
            header: 'F.REGISTRO',
            dataIndex: 'date_register',
            classHeader: 'text-center',
            classRow: 'text-center',
            // showTotal: false,
            isTotal: false, // 👈 sumará esta columna
            renderer: (value, row) => {
                const hasDiscount = Number(row.discount) > 0;

                return (
                    <span className={hasDiscount ? 'fw-bold' : ''}>
                        {value}
                    </span>
                );
            }
        },
        {
            header: 'HORA',
            dataIndex: 'hour_register',
            classHeader: 'text-center',
            classRow: 'text-center',
            // showTotal: false,
            isTotal: false, // 👈 sumará esta columna
        },
        {
            header: 'PERIODO CORTE',
            dataIndex: 'period_register',
            classHeader: 'text-center',
            classRow: 'text-center',
            // showTotal: false,
            isTotal: false, // 👈 sumará esta columna
        },
        {
            header: 'HORAS CORTE',
            dataIndex: 'hours_register',
            classHeader: 'text-center',
            classRow: 'text-center',
            // showTotal: false,
            isTotal: false, // 👈 sumará esta columna
        },
        {
            header: 'G. ESPERADAS ($)',
            dataIndex: 'expected_total',
            classHeader: 'text-center',
            classRow: 'text-center',
            // showTotal: true,
            isTotal: true, // 👈 sumará esta columna
            renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
        },
        {
            header: 'G. REALES ($)',
            dataIndex: 'real_total',
            classHeader: 'text-center',
            classRow: 'text-center',
            // showTotal: true,
            isTotal: true, // 👈 sumará esta columna
            renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
        },
        {
            header: 'ACCIONES',
            dataIndex: 'id',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value, row) => (
                <>
                    <button type="button" className="btn btn-outline-dark" onClick={() => searchDetail(value)}
                        data-bs-toggle="modal" data-bs-target="#detailPDF"
                    >
                        <FiPrinter size={22} />
                    </button>
                </>
            )
        },
    ];

    // console.log();
    let data = [];
    if (list_cashOut != undefined) {
        data = [...list_cashOut];
    }

    return (
        <div className='row'>
            <Modal />
            <div className="card">
                <div className="card-header">
                    <form className="row g-2" onSubmit={handleSubmit(searchData)}>
                        <div className="col-auto">
                            <label className="form-label"> No. de Corte</label>
                            <input type="text" className="form-control"  {...register("termino")} />
                        </div>
                        <div className="col-auto">
                            <label className="form-label">Fecha Inicial:</label>
                            <input type="date" className="form-control" defaultValue={today} {...register("fechaInicial", { required: 'Introduce fecha de inicio' })} />
                            {
                                errors.fechaInicial &&
                                <div className='text-left-5 mt-2'>
                                    <FiAlertTriangle size="18" color="#dc3545" />
                                    <span className='text-left-10 fw-bold text-danger'><small>{errors.fechaInicial.message}</small></span>
                                </div>
                            }
                        </div>
                        <div className="col-auto">
                            <label className="form-label">Fecha Final:</label>
                            <input type="date" className="form-control" defaultValue={today} {...register("fechaFinal", { required: 'Introduce fecha final' })} />
                            {
                                errors.fechaFinal &&
                                <div className='text-left-5 mt-2'>
                                    <FiAlertTriangle size="18" color="#dc3545" />
                                    <span className='text-left-10 fw-bold text-danger'><small>{errors.fechaFinal.message}</small></span>
                                </div>
                            }
                        </div>
                        <div className="col-auto mt-3">
                            <button type="submit" className="btn btn-outline-dark mt-esp">
                                <FiSearch size={20} /> <span className='text-left-5'>Buscar</span>
                            </button>
                        </div>
                    </form>
                </div>
                <div className="card-body border-top">
                    {
                        (isLoading) ?
                            (<Loading />) :
                            // <Table
                            //     columns={columns} data={data} function_={() => { }} placeholderSearch="Introduce No. de corte, fecha, monto..."
                            //     showPagination={true} showControls={true} tableHeight="500px" showTotals={true}
                            // />

                            <TableSummary
                                columns={columns}
                                data={data}
                                function_={()=>console.log('')}
                                placeholderSearch="Introduce No. de corte, fecha, monto..."
                                showPagination={false}
                                showControls={true}
                                showTotals={true}
                                countRow={false} // 👈 activa el contador de filas
                                showAverage={false}  // 👈 activa fila de promedio
                            />
                    }
                </div>
            </div>
        </div>
    )
}
